import api from '@/common/api';
import applyStatusHelper from '@/common/applyStatusHelper';
import RouteKey from '@/common/RouteKey';
import MessageType from '@/components/common/message-box/MessageType';
import DescriptionFolder from '@/components/common/DescriptionFolder';
import SubMenu from '../common/SubMenu';
import { KeyEnum, DisplayMapper } from '@/common/OptionConstant';
import FormItemUploadFile from '../common/FormItemUploadFile';
import DateUtils from '@/common/DateUtils';
import DeviceUtils from '@/common/utils/DeviceUtils';
import ErrorHandler from './ErrorHandler';
const DateFormat = DateUtils.DateFormat;
const DeviceStatus = {
  INACTIVE: 1
};
const IS_SUCCESS = 'is-success';
const IS_ERROR = 'is-error';
const contractTitle = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '正式合同'
};
const contractText = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '合同文件'
};
const LIST_NUM = 100;

export default {
  name: 'YoutuBoxDisplay',
  components: {
    DescriptionFolder,
    SubMenu,
    FormItemUploadFile
  },
  data() {
    return {
      RouteKey,
      applyStatusHelper,
      loaded: false,
      DisplayMapper,
      JoinWay: KeyEnum.JoinWay,
      BoxStatusKey: KeyEnum.YtboxApplyStatus,
      DeviceAuth: KeyEnum.DeviceAuth,
      BoxApplyKeyType: KeyEnum.YtboxApplyType,
      ytboxList: [],
      DeviceStatus,
      contractTitle: contractTitle[KeyEnum.JoinWay.EXTERNAL],
      contractText: contractText[KeyEnum.JoinWay.EXTERNAL],
      addDeviceVisible: false,
      addDeviceValidateData: {
        devno: ''
      },
      bindDeviceboxItem: null,
      groupAddDeviceVisible: false,
      groupDeviceFiles: null,
      bindDeviceBoxItem: null,
      ErrorName: 'GROUPDEVICE',
      validateGroupDeviceFileResult: {
        file: null,
        isValid: false
      },
      validateFile: false,
      YtboxApplyKeyType: KeyEnum.YtboxApplyType,
      YtboxStatusKey: KeyEnum.YtboxApplyStatus,
      contractVisible: false,
      validateFileContract: false,
      ErrorNameContract: 'INFO',
      bindContractItem: false,
      validateContractFile: {
        file: null,
        isValid: false
      },
      mailReceiverVisible: false,
      mailReceiverData: {
        receiver: ''
      },
      rulesReceiver: {
        receiver: [{
          type: 'string',
          required: true,
          message: '邮箱不能为空',
          trigger: ['blur, change']
        }, {
          max: 500,
          message: '不超过500字'
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }]
      },
      mailEditingItem: {}
    };
  },
  methods: {
    resetmailReceiverForm() {
      this.mailReceiverVisible = false;
      this.$refs.mailReceiverForm.resetFields();
    },
    showMailReceiverVisible(boxItem) {
      if (boxItem.mailreceiver.length > 0) {
        this.mailReceiverData.receiver = boxItem.mailreceiver;
      }
      this.mailEditingItem = boxItem;
      this.mailReceiverVisible = true;
    },
    submitChangeMailReceiver() {
      this.$refs.mailReceiverForm.validate((valid) => {
        if (valid) {
          this.mailReceiverVisible = false;
          const loading = this.loading();
          let mailreceiver = this.mailReceiverData.receiver;
          mailreceiver = mailreceiver.replace(/;/g, ',');
          mailreceiver = mailreceiver.replace(/；/g, ',');
          let data = {
            id: this.mailEditingItem.id,
            mailreceiver: mailreceiver
          };
          this.$loader.post(api.ytbox.MAIL, data, this.ajaxErrorCallback).then(() => {
            this.getAllYoutubox();
          }).finally(() => {
            this.mailEditingItem.mailreceiver = mailreceiver;
            this.resetmailReceiverForm();
            loading.close();
          });
        }
      });
    },
    validateDevno(rule, value, callback) {
      let reg = /^[-:a-zA-Z0-9_]+$/;
      if (value === '') {
        return callback(new Error('请输入设备号'));
      }
      if (!reg.test(value)) {
        return callback(new Error('设备号格式错误，请输入数字、字母、英文冒号或-'));
      }
      callback();
    },
    getAllYoutubox() {
      return this.$loader.post(api.ytbox.GET_ALL_YTBOX, {limit: LIST_NUM}, this.ajaxErrorCallback)
        .then(resData => {
          this.loaded = true;
          let lists = resData.items;
          lists.forEach(boxItem => {
            boxItem.mailreceiver = boxItem.mailreceiver == null ? boxItem.mailreceiver : boxItem.mailreceiver.replace(/,/g, ';');
            boxItem.ytcontact = boxItem.ytcontact == null ? boxItem.ytcontact : boxItem.ytcontact.replace(/,/g, ';');
            boxItem.deviceStatistics = DeviceUtils.processPrivateBox(boxItem);
            boxItem.optime = DateUtils.format(new Date(boxItem.optime), DateFormat.DEFAULT);
            boxItem.validbegin = boxItem.validbegin === 0 ? null : DateUtils.format(new Date(boxItem.validbegin), DateFormat.DEFAULT);
            boxItem.validend = boxItem.validend === 0 ? null : DateUtils.format(new Date(boxItem.validend), DateFormat.DEFAULT);
            if (boxItem.devices == null) {
              boxItem.devices = [{}, {}, {}, {}, {}];
            }
            let lengthDevice = boxItem.devices.length;
            if (lengthDevice < 5) {
              for (let i = lengthDevice; i < 5; i++) {
                boxItem.devices[i] = {};
              }
            }
          });
          this.ytboxList = lists;
        });
    },
    handleDeleteBox(boxItem) {
      this.$confirm('确认删除该优图盒子?', '提示', MessageType.INFO).then(() => {
        this.confirmDeleteBox(boxItem);
      });
    },
    confirmDeleteBox(boxItem) {
      return this.$loader.post(api.ytbox.REMOVE_YTBOX, {id: boxItem.id}, this.ajaxErrorCallback).then(() => {
        this.getAllYoutubox();
        this.$alert('删除优图盒子成功', null, MessageType.SUCCESS);
      });
    },
    // 删除设备
    handleDeleteDevice(boxItem, deviceItem) {
      if (deviceItem.status !== DeviceStatus.INACTIVE) {
        let data = {
          id: boxItem.id,
          devno: deviceItem.devno
        };
        this.$confirm('确认删除该设备', '提示', MessageType.INFO).then(() => {
          const loading = this.loading();
          this.$loader.post(api.ytbox.REMOVE_DEVICE, data, this.ajaxErrorCallback).then(() => {
            loading.close();
            this.getAllYoutubox();
          }).finally(() => {
            loading.close();
          });
        });
      }
    },
    deviceValidateResult(data) {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateGroupDeviceFileResult);
    },
    contractValidateResult(data) {
      let classItems = this.$refs.contract.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateContractFile);
    },
    handleValidateUploadResult(data, classItems, filesResult) {
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        filesResult.isValid = data.result;
        filesResult.file = data.file;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      filesResult.files = null;
      filesResult.isValid = false;
    },
    // 添加设备
    bindDeviceToYoutubox(boxItem) {
      this.addDeviceVisible = true;
      this.bindDeviceboxItem = boxItem;
      if (this.$refs.deviceForm) {
        this.$refs.deviceForm.resetFields();
      }
    },
    confirmBindDevice() {
      this.$refs.deviceForm.validate((valid) => {
        if (valid) {
          let boxItem = this.bindDeviceboxItem;
          let data = {
            id: boxItem.id,
            devno: this.addDeviceValidateData.devno,
            platform: KeyEnum.Platform.PLAT_YTBOX
          };
          this.addDeviceVisible = false;
          const loading = this.loading('绑定设备中');
          this.$loader.post(api.ytbox.BIND_DEVICE, data, this.ajaxErrorCallback).then(() => {
            loading.close();
            this.$alert('设备绑定成功', null, MessageType.SUCCESS);
            return this.getAllYoutubox();
          }).finally(() => {
            loading.close();
          });
        }
      });
    },
    // 批量添加
    bindGroupDeviceToYoutubox(boxItem) {
      this.groupAddDeviceVisible = true;
      this.bindDeviceBoxItem = boxItem;
      if (this.$refs.groupAddDeviceValidateData && this.$refs.groupAddDeviceValidateData.value) {
        this.$refs.groupAddDeviceValidateData.value = null;
      }
    },
    confirmGroupBindDevice() {
      this.validateFile = !(this.validateFile);
      if (this.validateGroupDeviceFileResult.isValid === false) {
        return;
      }
      let boxItem = this.bindDeviceBoxItem;
      let data = {
        id: boxItem.id
      };
      let file = {
        file: this.validateGroupDeviceFileResult.file
      };
      const loading = this.loading('绑定设备中');
      this.$loader.upload(api.ytbox.MULTIBIND_DEVICE, data, file, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('设备绑定成功', null, MessageType.SUCCESS);
        return this.getAllYoutubox();
      }).finally(() => {
        this.cancleBindGroupDevice();
        loading.close();
      });
    },
    cancleBindGroupDevice() {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.groupAddDeviceVisible = false;
      this.validateFile = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.validateGroupDeviceFileResult = {
        file: null,
        isValid: false
      };
    },
    // 申请正式授权
    handleChangeToFormalBox(boxItem) {
      if (boxItem.scope === KeyEnum.JoinWay.INTERNAL) {
        this.contractText = contractText[KeyEnum.JoinWay.INTERNAL];
        this.contractTitle = contractTitle[KeyEnum.JoinWay.INTERNAL];
      } else {
        this.contractText = contractText[KeyEnum.JoinWay.EXTERNAL];
        this.contractTitle = contractTitle[KeyEnum.JoinWay.EXTERNAL];
      }
      this.contractVisible = true;
      this.bindContractItem = boxItem;
    },
    confirmApplyAuth() {
      this.validateFileContract = !(this.validateFileContract);
      let boxItem = this.bindContractItem;
      let contractFile = this.validateContractFile;
      if (boxItem.scope === KeyEnum.JoinWay.INTERNAL) {
        if (contractFile.isValid === false) {
          return;
        }
        this.doSubmitApply(boxItem);
      }
      if (contractFile.isValid === false) {
        return;
      }
      this.doSubmitApply(boxItem);
    },
    doSubmitApply(boxItem) {
      let data = {
        id: boxItem.id
      };
      let file = {
        contract: this.validateContractFile.file
      };
      const loading = this.loading();
      this.$loader.upload(api.ytbox.PRODUCTIZE_AUTH, data, file, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.getAllYoutubox();
      }).finally(() => {
        loading.close();
        this.cancleContractForm();
      });
    },
    cancleContractForm() {
      let classItems = this.$refs.contract.$el.classList;
      this.contractVisible = false;
      this.validateFileContract = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.validateContractFile = {
        file: null,
        isValid: false
      };
    },
    openCreateBox() {
      if (this.ytboxList.length >= LIST_NUM) {
        this.$alert('可申请优图盒子授权数量上限为100，如需继续申请，请删除列表中的部分授权', '申请数量超限', MessageType.FAIL);
      } else {
        this.$router.transfer(RouteKey.OPEN_YOUTU_BOX_CREATOR, {id: this.ytboxList[0].id});
      }
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.getAllYoutubox();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/YoutuBoxDisplay.js